import { useParams } from 'react-router-dom';
import modpacks from '../data/modpacks';

export default function ModpackPage() {
  const { id } = useParams();
  const modpack = modpacks.find(mp => mp.id === id);

  if (!modpack) return <p>Modpack not found.</p>;

  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">{modpack.name}</h1>
      <p className="mb-6 font-bold">Server IP: {modpack.ip}</p>
      <p className="mb-6 font-semibold">Version: {modpack.version}</p>
      <p className="mb-6">{modpack.short}</p>
      <p className="mb-6">{modpack.description}</p>
      {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {modpack.images.map((img, index) => (
          <img key={index} src={img} alt={`${modpack.name} screenshot ${index + 1}`} className="rounded-lg shadow"/>
        ))}
      </div> */}
    </div>
  );
}